import { ChildParent } from 'types';

export const checkIfParentHaveDuplicatedEmails = (parentsData: ChildParent[]) => {
    const emails = parentsData.map((parent) => parent.email);
    const uniqueEmails = new Set(emails);

    return emails.length !== uniqueEmails.size;
};
